const ObjectToArray = (data) => {
  let ExcelArray = [];

  ExcelArray.push(Object.keys(data[0]));

  data.forEach((row) => {
    ExcelArray.push(Object.values(row));
  });
  return ExcelArray;
};

const fileDownloadPeer = (downloadData, title) => {
  const excelData = ObjectToArray(downloadData);

  let excelHandler = {
    getExcelFileName: () => {
      return `${title}.xlsx`;
    },
    getSheetName: () => {
      return 'Sheet';
    },
    getWorksheet: () => {
      return XLSX.utils.aoa_to_sheet(excelData);
    },
  };

  const workbook = XLSX.utils.book_new();
  let newWorkSheet = excelHandler.getWorksheet();

  // if (!newWorkSheet['!merges']) newWorkSheet['!merges'] = [];
  // newWorkSheet['!merges'] = this.mergedExcelRow;

  XLSX.utils.book_append_sheet(workbook, newWorkSheet, excelHandler.getSheetName());
  const workbookOut = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  saveAs(
    new Blob([workbookOut], { type: 'application/octet-stream' }),
    excelHandler.getExcelFileName()
  );
};

const fileDownloadSaai = (downloadData, questions, isViewResult, locale) => {
  const XLSX = require('xlsx');
  const resultData = downloadData;

  let xlsxData = [];
  let sheetNumber = 0;

  resultData.forEach((sheet) => {
    let data =
      locale === 'eng'
        ? [
            [
              'id',
              questions[sheetNumber],
              'number of words',
              'missing important keywords',
              'score',
              'interval',
              'feedback',
            ],
          ]
        : [['id', questions[sheetNumber], '단어 수', '빠진 중요어', '점수', '구간', '피드백 문구']];

    sheet.forEach((item) => {
      let row = [];
      if (isViewResult) {
        row = [
          item.id,
          item.answer,
          item.number_of_import_words,
          item.missing_important_word.join(','),
          item.score,
          item.interval,
          item.feedbackComment,
        ];
      } else {
        row = [
          item.student_id,
          item.content,
          item.keyword_num,
          item.missing_keywords,
          item.score,
          item.interval_of_student,
          item.feedback_comment,
        ];
      }
      data.push(row);
    });

    xlsxData.push({ name: null, data: data });
    sheetNumber++;
  });

  const workbook = XLSX.utils.book_new();

  for (let i = 0; i < xlsxData.length; i++) {
    const sheet = XLSX.utils.aoa_to_sheet(xlsxData[i].data);
    XLSX.utils.book_append_sheet(workbook, sheet, xlsxData[i].name);
  }

  const filename = 'result.xlsx';
  XLSX.writeFile(workbook, filename);
};

export { fileDownloadPeer, fileDownloadSaai };
